import { render, staticRenderFns } from "./group-connected-accounts.vue?vue&type=template&id=64c8e7ea&scoped=true"
import script from "./group-connected-accounts.vue?vue&type=script&lang=js"
export * from "./group-connected-accounts.vue?vue&type=script&lang=js"
import style0 from "./group-connected-accounts.vue?vue&type=style&index=0&id=64c8e7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8e7ea",
  null
  
)

export default component.exports